import { useTheme } from "@/lib/theme";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export function DarkModeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const { t } = useTranslation("common");

  const isDark = resolvedTheme === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? t("switchToLightMode") : t("switchToDarkMode")}
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className={cn(
        "relative w-8 h-[18px] rounded-full flex-shrink-0 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        isDark ? "bg-brand" : "bg-secondary"
      )}
    >
      <span
        className={cn(
          "absolute top-0.5 w-3.5 h-3.5 rounded-full bg-white shadow-sm transition-[left] duration-200",
          isDark ? "left-[calc(100%-0.875rem-2px)]" : "left-0.5"
        )}
      />
    </button>
  );
}
